jQuery(document).ready(function(){
   //jQuery('.gradient').fadeIn(3000);
  // localStorage.removeItem("first_time")
  console.log(localStorage.getItem('site_load'))
  
//    jQuery(".preload").fadeOut(2000, function() {
//         jQuery(".content").fadeIn(100);        
//     });

/*  jQuery.get('https://www.cloudflare.com/cdn-cgi/trace', function(data) {
    // Convert key-value pairs to JSON
    data = data.trim().split('\n').reduce(function(obj, pair) {
      pair = pair.split('=');
      return obj[pair[0]] = pair[1], obj;
    }, {});
    console.log(data);
  });
  
*/  
   jQuery('.country-switch').click(function(){

    // Example of use:
    //setCookie('country', jQuery(this).data('url'), {secure: true, 'max-age': 7200});
    //localStorage.setItem('country', jQuery(this).data('url'));
    //localStorage.setItem('fullUrl',jQuery(this).data('fullurl'));
    //console.log('current url',jQuery(this).data('fullurl'))
    jQuery('.gradient').fadeOut(2000);
    window.location.replace(jQuery(this).data('fullurl'));
    
    //localStorage.removeItem("first_time")
	
    

  })
	console.log(localStorage.getItem('fullUrl'));

  //jQuery('.header__heading-link').attr('href','https://gb.simplysensitivitychecks.com/');

  
  jQuery('.country').hide();
  jQuery('#home-banner-uk').hide();
  jQuery('#home-banner-aus').hide();
  jQuery('#home-banner-usa').hide();
  jQuery('#home-banner-ire').hide();
  jQuery('#home-banner-nz').hide();
  jQuery('#home-banner-ca').hide();

  jQuery('.home-test-steps').hide();
  jQuery('.home-test-steps-au').hide();
  jQuery('.home-test-steps-ca').hide();
  jQuery('.home-test-steps-ire').hide();
  jQuery('.home-test-steps-nz').hide();
  jQuery('.home-test-steps-us').hide();
  jQuery('.home-test-steps-uk').hide();

  //pages section for About page
  jQuery('.about-page-banner').hide();
  jQuery('.about-page-content').hide();

  jQuery('.video-sec').hide();

  jQuery('.allergy-uk').hide();
  jQuery('.allergy-usa').hide();
  jQuery('.allergy-aus').hide();
  jQuery('.allergy-ire').hide();
  jQuery('.allergy-can').hide();
  jQuery('.allergy-nz').hide();

  jQuery('.img-usa').hide();

  jQuery('.address').hide();
  jQuery('.extra-description').hide();

  //jQuery('.header-menu').hide();
  jQuery('.country-selector').click(function(){

    if(jQuery('.country-selector').data('val')==0){
      jQuery('.country-selector').removeClass('inactive');
      jQuery('.country-selector').addClass('active');
      jQuery('.country-selector').data('val',1);
    }else{
      jQuery('.country-selector').removeClass('active');
      jQuery('.country-selector').addClass('inactive');

      jQuery('.country-selector').data('val',0);
    }
    jQuery('.switcher-box').toggle();

  })
jQuery(".content").fadeIn(100);       
  jQuery(".mobile-menu").hide()


    jQuery('#home-banner-ca').show();
    jQuery('.home-test-steps-uk').show();
    jQuery('.video-sec').show();
    jQuery('.content-II').hide();
    jQuery('.allergy-uk').show();
    jQuery('.about-page-banner-uk').show();
    jQuery('.about-page-content-uk').show();
    jQuery('.extra-description-uk').show();
    jQuery('.address-uk').show();
    jQuery('.ca').show();
    jQuery('.top-header-menu-uk').show();
    jQuery('.footer-menu-uk').show();
    jQuery(".mobile-menu-uk").show()
    jQuery('body').addClass('body-uk');


  jQuery('#others_alergy').hide();
  jQuery('#others_alergy_env').hide();

  jQuery('#cb23').click(function(){
    if(jQuery(this).is(":checked")){
      jQuery('#others_alergy_env').show();
    }else{
      jQuery('#others_alergy_env').hide();
    }
  })

  jQuery('#cb6').click(function(){
    if(jQuery(this).is(":checked")){
      jQuery('#others_alergy').show();
    }else{
      jQuery('#others_alergy').hide();
    }
  })


  jQuery('#confirmemail').blur(function(){

    if((jQuery(this).val() !='' && jQuery('#emailaddress').val()!='') && (jQuery(this).val() != jQuery('#emailaddress').val())){
      jQuery(this).val(' ');
      jQuery('.errmail').html('Email and bconfirm email are not same');
    }else{
      jQuery('.errmail').html(' ');
    }
  })

  jQuery('.why-us').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots:false,
    autoplay:true,
    responsive:{
      0:{
        items:2,
        nav:false,
        dots:true,
      },
      600:{
        items:3,
        nav:false,
        dots:true,
      },
      800:{
        items:4,
        nav:false,
        dots:true,
      },
      1000:{
        items:5,
        nav:false,
        dots:true,
      },
      1200:{
        items:6,
        nav:true,
      }
    }
  });

  jQuery('#brand-slider').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    dots:false,
    autoplay:true,
    responsive:{
      0:{
        items:2,
        nav:false,
        dots:true,
      },
      800:{
        items:3,
        nav:false,
        dots:true,
      },
      1000:{
        items:4,
        nav:false,
        dots:true,
        loop:false,
      },
      1200:{
        items:4,
        nav:true,
      }
    }
  })

  jQuery('.card-header').click(function(){

    var index=jQuery(this).data('id');

    if(jQuery(this).data('val')==0){
      jQuery('.card-title-'+index).removeClass('collapsed');
      jQuery(this).data('val',1);
    }else{
      jQuery('.card-title-'+index).addClass('collapsed');
      jQuery(this).data('val',0);
    }

    jQuery('#collapse-'+index).toggle(1000);
  })

  jQuery('.about-test').click(function(){

    var index=jQuery(this).data('id');
    //alert(jQuery(this).data('val'));
    if(jQuery(this).data('val')==1){
      jQuery('.about-test-'+index).addClass('collapsed');
      jQuery(this).attr('data-val', '0');
    }else{
      jQuery('.about-test-'+index).removeClass('collapsed');
      jQuery(this).attr('data-val', '1');
    }

    jQuery('#collapse-test-'+index).toggle(1000);
  })

  jQuery('.sending-sample').click(function(){

    var index=jQuery(this).data('id');
    if(jQuery(this).data('val')==0){
      jQuery('.sending-sample-'+index).removeClass('collapsed');
      jQuery(this).attr('data-val', '1');
    }else{
      jQuery('.sending-sample-'+index).addClass('collapsed');
      jQuery(this).attr('data-val', '0');
    }
    jQuery('#collapse-sample-'+index).toggle(1000);
  })

  jQuery('.test-result').click(function(){

    var index=jQuery(this).data('id');
    if(jQuery(this).data('val')==0){
      jQuery('.test-result-'+index).removeClass('collapsed');
      jQuery(this).attr('data-val', '1');
    }else{
      jQuery('.test-result-'+index).addClass('collapsed');
      jQuery(this).attr('data-val', '0');
    }

    jQuery('#collapse-result-'+index).toggle(1000);
  })

  jQuery('.test-advance').click(function(){

    var index=jQuery(this).data('id');
    if(jQuery(this).data('val')==0){
      jQuery('.test-advance-'+index).removeClass('collapsed');
      jQuery(this).attr('data-val', '1');
    }else{
      jQuery('.test-advance-'+index).addClass('collapsed');
      jQuery(this).attr('data-val', '0');
    }

    jQuery('#collapse-advance-'+index).toggle(1000);
  })

  jQuery('.test-ultimate').click(function(){

    var index=jQuery(this).data('id');
    if(jQuery(this).data('val')==0){
      jQuery('.test-ultimate-'+index).removeClass('collapsed');
      jQuery(this).attr('data-val', '1');
    }else{
      jQuery('.test-ultimate-'+index).addClass('collapsed');
      jQuery(this).attr('data-val', '0');
    }

    jQuery('#collapse-ultimate-'+index).toggle(1000);
  })



  jQuery('#submit-btn').click(function(){
    if (jQuery('#ContactForm-cbtandc').is(':checked')) {
      jQuery('#ContactFormtrackorder').submit();
      //return true;
    } else {
      //$(this).prop('checked',true);
      return false;
    }
  })


 

  function setCookie(name, value, options = {}) {

    options = {
      path: '/',
      // add other defaults here if necessary
      ...options
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (let optionKey in options) {
      updatedCookie += "; " + optionKey;
      let optionValue = options[optionKey];
      if (optionValue !== true) {
        updatedCookie += "=" + optionValue;
      }
    }

    document.cookie = updatedCookie;
  }



  console.log('current cookie', getCookie('country'));
  function getCookie(name) {
    let matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }



  // alert the value to check if we got it
  //alert(localStorage.getItem('country'));

  //script for slider 
    var slideIndex = 1;
    showSlides(slideIndex);

    function plusSlides(n) {
      showSlides(slideIndex += n);
    }

    function currentSlide(n) {
      showSlides(slideIndex = n);
    }

    jQuery('.prev').click(function(){

      showSlides(slideIndex--);
    })

    jQuery('.next').click(function(){

      showSlides(slideIndex++);
    })

    jQuery('.slide-thumbnail').click(function(){
      showSlidesClick(slideIndex =jQuery(this).data('index'));
    })

    function showSlides(n) {

      var i;
      var slides = document.getElementsByClassName("slides");
      console.log(slides.length)
      var dots = document.getElementsByClassName("slide-thumbnail");

      if (n >= slides.length) 
      {
        slideIndex = 1;


      }
      if (n == 0) 
      {
        slideIndex = slides.length;

      }
      console.log(slideIndex);

      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";

      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[slideIndex-1].style.display = "block";
      dots[slideIndex-1].className += " active";

    }

    function showSlidesClick(n) {
      // alert(n)
      var i;
      var slides = document.getElementsByClassName("slides");
      console.log(slides.length)
      var dots = document.getElementsByClassName("slide-thumbnail");
      //var captionText = document.getElementById("caption");

      console.log(slideIndex);

      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
        // slides[i].style.display = "inline";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[slideIndex-1].style.display = "block";
      // slides[slideIndex-1].style.display = "inline";
      dots[slideIndex-1].className += " active";
      //captionText.innerHTML = dots[slideIndex-1].alt;
    }
  ;


//   jQuery('.big-image').ezPlus({
//     constrainType: 'height', constrainSize: 274, zoomType: 'lens',
//     containLensZoom: true, gallery: 'gallery_01', cursor: 'pointer', galleryActiveClass: 'active'
// });

//pass the images to Fancybox
// jQuery('.big-image').bind('click', function (e) {
//     var ez = jQuery(this).data('ezPlus');
//     jQuery.fancyboxPlus(ez.getGalleryList());
//     return false;
// });

})


